
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCheckboxChecked as ObiCheckboxCheckedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-checkbox-checked.js';
 
 
 

 
 export const ObiCheckboxChecked = createComponent({
   react: React,
   tagName: 'obi-checkbox-checked',
   elementClass: ObiCheckboxCheckedElement,
   events: {
     
   }
  });
 
 